import React from 'react';
import { fiverr_affiliates_logo as FiverrAffiliatesLogo } from '@fiverr-private/icons/logos';
import { LanguageSelectionPopoverEntry } from '@fiverr-private/locale_settings';
import { Stack } from '@fiverr-private/layout_components';
import { AffiliatesLink, Blog, CommissionPlan, Login } from '../shared/Link';
import { SUPPORTED_LOCALES } from '../const';
import { SupportCollapsible } from './HeaderCollapsible/SupportCollapsible';
import { ResourcesCollapsible } from './HeaderCollapsible/ResourcesCollapsible';
import { ArrowIcon } from './HeaderCollapsible/ArrowIcon';

import { languageSelectorEntryClass } from './styles.ve.css';

const Header = () => (
  <Stack
    as="header"
    borderBottomWidth="sm"
    borderColor="grey_400"
    paddingX="5"
    paddingY={{ default: '6', sm: '8' }}
    direction={{ default: 'column', md: 'row' }}
    justifyContent="spaceBetween"
    alignItems="center"
  >
    <Stack alignItems="center" width="auto">
      <AffiliatesLink path="/" type="button" clickText={'icon'}>
        <FiverrAffiliatesLogo />
      </AffiliatesLink>
    </Stack>
    <Stack
      as="nav"
      gap="6"
      paddingTop={{ default: '4', md: '0' }}
      justifyContent={{ default: 'center', md: 'flexEnd' }}
      alignItems="center"
      hidden={{ default: true, sm: false }}
    >
      <Stack alignItems="center" role="menu" width="auto" gap="0" aria-label="language-selection">
        <LanguageSelectionPopoverEntry className={languageSelectorEntryClass} supportedLanguages={SUPPORTED_LOCALES} />
        <ArrowIcon />
      </Stack>
      <CommissionPlan variant="header" />
      <SupportCollapsible />
      <ResourcesCollapsible />
      <Blog variant="header" />
      <Login variant="header" />
    </Stack>
  </Stack>
);

export default Header;
